import React, { useRef, useState } from 'react'
import Scrollspy from 'react-scrollspy';
import { logoWhiteSvg } from '../../assets';
import { CloseRounded, MenuRounded, } from '@mui/icons-material';
import { ImageBuffer, ToggleModeButton } from '../'
import { navLinks } from '../../utils/constants'
import { Link } from 'react-scroll'
import './navbar.css'

const Navbar = ({theme}: any) => {
  const modalNavRef               = useRef<HTMLDivElement | null>(null);
  const [toggleNav, setToggleNav] = useState(false)

  const closeNavModal = (e: React.MouseEvent<HTMLDivElement>) => {
    if(modalNavRef.current === e.target){
      setToggleNav(false)
    }
  }

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-logo'>
          <ImageBuffer src={logoWhiteSvg} alt='logo' />
        </div>
        <div className='navbar-show-btn navbar-open-close' onClick={() => setToggleNav((prev) => !prev)}><MenuRounded /></div>

        <div className={toggleNav ? 'navbar-collapse navbar-show' : 'navbar-collapse'} ref={modalNavRef} onClick={closeNavModal}>
          <div className='navbar-collapse-inner'>
            <div className='navbar-center'>
              <div className='navbar-hide-btn navbar-open-close' onClick={() => setToggleNav((prev) => !prev)}><CloseRounded /></div>
              <Scrollspy items={navLinks.map((result) => result.name.toLowerCase())} currentClassName="active" offset={-70}>
                <ul>
                  {navLinks.map((result, index) => (
                    <li key={index}><Link to={result.name.toLowerCase()} spy={true} offset={-70} duration={500} className='anchor' onClick={() => setToggleNav((prev) => !prev)}>{result.name}</Link></li>
                  ))}
                </ul>
              </Scrollspy>
            </div>
            <ToggleModeButton theme={theme} />
          </div>
        </div>
      </nav>
    </>
  )
}

export default Navbar